import React, { Fragment } from 'react'
import { Heading } from '@myxplor/ui'

const GovPersonnelEmpty = ({ gov_registration }) => (
  <Fragment>
    <Heading small>No Matching {gov_registration.care_type.toUpperCase()} Registrations</Heading>
    <p>
      No government {gov_registration.care_type.toUpperCase()} registrations found for this
      personnel.
    </p>
  </Fragment>
)

export default GovPersonnelEmpty



// WEBPACK FOOTER //
// ./src/personnel/details/gov-personnel/views/empty.jsx